export default __webpack_public_path__ + "c422a766a0391e4ddd749c072dc9a47e.pdf";